// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Minimize = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill}
      stroke={stroke}
      strokeWidth="2px"
    >
      <polyline points="32.12 15.88 32.34 15.67 44 4" />
      <polygon points="31.68 11.63 32.49 11.67 32.34 15.66 36.34 15.52 36.37 16.33 31.5 16.5 31.68 11.63" />
      <polyline points="4 4 15.66 15.67 15.87 15.88" />
      <polygon points="16.5 16.5 11.63 16.33 11.66 15.52 15.66 15.66 15.51 11.67 16.32 11.63 16.5 16.5" />
      <polyline points="44 44 32.34 32.33 32.13 32.12" />
      <polygon points="31.5 31.5 36.37 31.67 36.34 32.48 32.34 32.34 32.49 36.33 31.68 36.37 31.5 31.5" />
      <polyline points="15.88 32.12 15.66 32.33 4 44" />
      <polygon points="16.32 36.37 15.51 36.33 15.66 32.34 11.66 32.48 11.63 31.67 16.5 31.5 16.32 36.37" />
    </svg>
  );
};
